// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDA2Os9bZxVtOTIEhijlTBuyqHOfd14iBA",
  authDomain: "turismozahara.firebaseapp.com",
  projectId: "turismozahara",
  storageBucket: "turismozahara.appspot.com",
  messagingSenderId: "12292589980",
  appId: "1:12292589980:web:49d8603e598cbef63f2059",
  measurementId: "G-KPPJKRYDVD",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
